import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DateAdapter,
  MatDateFormats,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { MatCalendar, MatCalendarView } from '@angular/material/datepicker';
import { DateTime } from 'luxon';

@Component({
  selector: 'pl-calendar-header',
  styleUrls: ['./pl-calendar-header.component.scss'],
  templateUrl: './pl-calendar-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlCalendarHeaderComponent {
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private _calendar: MatCalendar<DateTime>,
    private _dateAdapter: DateAdapter<DateTime>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef
  ) {
    _calendar.stateChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => cdr.markForCheck());
  }

  get currentView() {
    return this._calendar.currentView;
  }

  get periodLabel() {
    if (this.currentView === 'year') {
      return this._calendar.activeDate.get('year');
    }
    return this._dateAdapter.format(
      this._calendar.activeDate,
      this._dateFormats.display.monthYearLabel
    );
  }

  openMonthView() {
    this._calendar.currentView = 'year';
  }

  previousClicked(mode: MatCalendarView) {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: MatCalendarView) {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}
